import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../common/Modal';
import Grid from '../../../Grid';
import styles from './SubmitModal.module.sass';
import { Student } from '../../../../models/_models';

const SubmitModal = ({ studentId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [ignoreWarning, setIgnoreWarning] = useState(false);
  const [currentTeacher, setCurrentTeacher] = useState();

  useEffect(() => {
    if (!studentId) return;

    Student.find(studentId).then((res) => {
      setCurrentTeacher(res.data)
    })
  }, [isOpen]);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const useModal = (e) => {
    e.preventDefault();

    openModal();
  }

  const handleAccept = (status) => {
    setAccepted(true)
    $('#approved_input').val(status);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    $('#edit_educator').data('remote', false)

    $('#edit_educator').submit();
  }

  const handleSave = (e) => {
    e.preventDefault();

    $('#edit_educator').data('remote', false)
    $('#edit_educator').submit();
  }

  const displayName = () => $('#educator_display_name').val();

  const nameMismatchError = () => {
    if (!currentTeacher) return false;

    return (
      displayName() && ['mr', 'mrs', 'ms', 'miss'].some(val => displayName().toLowerCase().includes(val)) &&
        currentTeacher && !['mr', 'mrs', 'ms', 'miss'].some(val => currentTeacher.fullName().toLowerCase().includes(val))
    );
  }

  const singleWordNameError = () => (
    displayName() && displayName().split(' ').length <= 1
  )

  const modalContent = () => {
    if ((nameMismatchError() || singleWordNameError()) && !ignoreWarning) {
      return (
        <>
          <h3 className={styles.header}>
            Please verify the following warnings:
          </h3>

          <ul>
            {nameMismatchError() && (
              <li>
                Your display name is specified as {displayName()}, but the name on your class picture is {' '}
                {currentTeacher.fullName()}. Please double check to make sure your name under
                your photo in the class picture is correct.
              </li>
            )}

            {singleWordNameError() && (
              <li>
                Your display name is specified as {displayName()}. Please add a first name or a title (Mr., Ms., Mrs., Miss, etc)
              </li>
            )}
          </ul>

          <hr />

          <Grid container>
            <Grid container item direction='column' alignItems='center' justify='center' xs={6}>
              <button className="btn btn-primary" onClick={closeModal}>
                Address Issues
              </button>
            </Grid>

            <Grid container item direction='column' alignItems='center' justify='center' xs={6}>
              <button className="btn btn-primary" onClick={() => { setIgnoreWarning(true) }}>
                Continue Anyway
              </button>
            </Grid>
          </Grid>
        </>
      )
    }

    return (
      <div>
        <h3 className={styles.header}>
          What is the current status of your class picture?
        </h3>

        <hr />

        <Grid container>
          <Grid container item direction='column' alignItems='center' justify='center' xs={12}>
            <div className={styles.inputContainer}>
              <label htmlFor="accept">
                <div className={styles.notReady}>
                  <input type="radio" value="1" name="corrections_ready" onChange={() => handleAccept('false')} /> {' '}
                  <span>Save Changes Only</span><br/>
                  <span>Class Picture is not ready to print</span>
                </div>

                <div className={styles.needsChanges}>
                  <input type="radio" value="1" name="corrections_ready" onChange={() => handleAccept('corrections')} /> {' '}
                  <span>I certify that this class picture is ready to print after the changes I have requested are made.</span>
                </div>

                <div className={styles.ready}>
                  <input type="radio" value="1" name="corrections_ready" onChange={() => handleAccept('true')} /> {' '}
                  <span>I certify that all corrections have been made and this class picture is ready to print.</span>
                </div>
              </label>
            </div>

            <button className="btn btn-success" disabled={!accepted} onClick={handleSubmit}>
              Submit corrections
            </button>
          </Grid>
        </Grid>
      </div>
    )
  }

  return (
    <>
      <button onClick={useModal} className="btn btn-success">
        Save Corrections
      </button>

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Save Corrections"
        headerText="Save Corrections"
      >
        {modalContent()}
      </Modal>
    </>
  )
}

SubmitModal.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
}

SubmitModal.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search All',
}

export default SubmitModal
